<ng-container *ngIf="!item?.moduleName || hasActiveModule(item?.moduleName ?? '')">
  <mat-divider [ngClass]="{
          'active': item?.route ?? '' ? router.isActive(item?.route ?? '', { paths: item?.exactPath ?? ''? 'exact' : 'subset',  fragment:'exact',  matrixParams:'exact',  queryParams:'ignored'  }): false,
          'expanded': expanded

        }"></mat-divider>
  <a mat-list-item [ngStyle]="{'padding-left': ((depth ?? 0) * 12) + 'px'}" (click)="onItemSelected(item)" [ngClass]="{
          'active': item?.route ?? '' ? router.isActive(item?.route ?? '', { paths: item?.exactPath? 'exact' : 'subset',  fragment:'exact',  matrixParams:'exact',  queryParams:'ignored'  }): false,
          'expanded': expanded,
          'sublevel': depth ?? 0> 0
          }">
    <div class="displayName" *ngIf="item">
      <mat-icon class="routeIcon">{{item.iconName}}</mat-icon>
      <div [ngClass]="{
          'sublevel': depth ?? 0 > 0
    }">
<!--        {{item.displayName | translate }}-->
      </div>
    </div>
    <span fxFlex *ngIf="item && item.children && item.children.length">
      <span fxFlex></span>
      <mat-icon [@indicatorRotate]="expanded ? 'expanded': 'collapsed'">
        expand_more
      </mat-icon>
    </span>
  </a>
  <mat-divider *ngIf="item" [ngClass]="{
        'active': item.route ? router.isActive(item.route, { paths: item.exactPath? 'exact' : 'subset',  fragment:'exact',  matrixParams:'exact',  queryParams:'ignored'  }): false, 'expanded': expanded
      }"></mat-divider>
  <div *ngIf="expanded && depth && item && item.children" >
    <app-menu-list-item *ngFor="let child of item.children" [item]="child" [depth]="depth+1"
      [modulesActives]="modulesActives">
    </app-menu-list-item>
  </div>
</ng-container>
